import { ALERT_ACTION_TYPES} from "../../_constants";

const triggerAlert = (isOpen: boolean, message: string, severity: string, duration: number = 3000) => {
    return action => {
        const data = {
            isOpen,
            message,
            severity,
            duration
        }
        action({type: ALERT_ACTION_TYPES.TRIGGER, data})
    }
}

const clearAlert = () => {
    return {type: ALERT_ACTION_TYPES.CLEAR}
}

export const alertActions = {
    triggerAlert,
    clearAlert
}
